export default __webpack_public_path__ + "static/media/english_white.8d5ba760.svg";